// Default State
const initialState = {};

// Reducer
function reducer(state = initialState, action) {
  switch (action.type) {
    case 'LOAD_RESUMES':
      return action.data;
    default:
      return state;
  }
}

// Exports Default
export default reducer;
